import { PersonalPlanning } from "app/models/timeslot"
import { PersonalPlanningParams } from "./personalPlanning.reducer"

export enum Types {
  GET = "PERSONAL_PLANNING_TIMESLOTS_GET",
  GET_SUCCESS = "PERSONAL_PLANNING_TIMESLOTS_GET_SUCCESS",
  GET_FAIL = "PERSONAL_PLANNING_TIMESLOTS_GET_FAIL",
}

export type Action = GetTimeslotsAction | GetTimeslotsSuccessAction | GetTimeslotsFailAction

export type GetTimeslotsAction = {
  payload: { params: PersonalPlanningParams }
  type: Types.GET
}

export type GetTimeslotsSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { data: PersonalPlanning }
}

export type GetTimeslotsFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export function getPersonalPlanningTimeslots(params: PersonalPlanningParams): GetTimeslotsAction {
  return {
    payload: { params },
    type: Types.GET,
  }
}

export function getPersonalPlanningTimeslotsSuccess(data: PersonalPlanning): GetTimeslotsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getPersonalPlanningTimeslotsFail(errors: object): GetTimeslotsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
